import { Avalista } from './avalista';

export class Proposta {
  id: string;
  avalistas: Avalista[] = [];
}
